import { pnDueActions } from '_actions'
import { createReducer } from '@reduxjs/toolkit'
import { log } from '_services'

const initialState = {
    selectedMessage: undefined,
    loading: false,
    detailsLoading: false
};

export const reducer = createReducer(initialState, {
    [pnDueActions.setSelectedMessage]: (state, action) => {
        state.selectedMessage = action.payload.epno;
    },
    [pnDueActions.markReadFailure]: (state, action) => {
        log.error('Error marking note as read. epno: ' + action.payload.epno + ' error: ' + action.payload.error);
    },
    [pnDueActions.loadRequest]: (state, action) => {
        state.loading = true;
    },
    [pnDueActions.loadSuccess]: (state, action) => {
        state.loading = false;
    },
    [pnDueActions.loadFailure]: (state, action) => {
        state.loading = false;
        log.error('Error loading notes requiring progress. error: ' + action.payload.error);
    },
    [pnDueActions.loadDetailsRequest]: (state, action) => {
        state.detailsLoading = true;
    },
    [pnDueActions.loadDetailsSuccess]: (state, action) => {
        state.detailsLoading = false;
    },
    [pnDueActions.loadDetailsFailure]: (state, action) => {
        state.detailsLoading = false;
        log.error('Error loading PN Due details.  epno: ' + action.payload.epno + ' error: ' + action.payload.error);
    },
    [pnDueActions.clearSelection]: (state, action) => {
        state.selectedMessage = undefined;
    },

})


